import { render, staticRenderFns } from "./OpenApiJointInfo.vue?vue&type=template&id=04540362&scoped=true&"
import script from "./OpenApiJointInfo.vue?vue&type=script&lang=js&"
export * from "./OpenApiJointInfo.vue?vue&type=script&lang=js&"
import style0 from "./OpenApiJointInfo.vue?vue&type=style&index=0&id=04540362&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04540362",
  null
  
)

export default component.exports